<template>
    <div class="row mx-auto my-5">
        <div class="col-8">
            <!-- Header -->
            <div class="mb-4">
                <h2>{{ $t("transportations.addTransportation") }}</h2>
            </div>
            <!-- Error -->
            <div>
                <div v-if="error" class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
            </div>
            <!-- Form -->
            <div class="d-flex gap-3">
                <div class="mb-3">
                    <input class="form-check-input me-2" type="radio" name="transportType" id="standardTransport"
                        value="Standardní" v-model="postData.transportType.transportType">
                    <label class="form-check-label" for="standardTransport">
                        {{ $t("transportations.standardTransport") }}
                    </label>
                </div>
                <div class="mb-3">
                    <input class="form-check-input me-2" type="radio" name="transportType" id="bezrukaceTransport"
                        value="bezrukaceTransport" v-model="postData.transportType.transportType">
                    <label class="form-check-label" for="bezrukaceTransport">
                        {{ $t("transportations.bezrukaceTransport") }}
                    </label>
                </div>
                <div v-if="postData.transportType.transportType == 'bezrukaceTransport'">
                    <div class="mb-3">
                        <span>{{ $t('transportations.choices') }}</span>
                        <div class="mt-2">
                            <div class="mb-2">
                                <input class="form-check-input me-2" type="radio"
                                    v-model="postData.transportType.choice" value="LesProfi">
                                <label class="form-check-label">LesProfi</label>
                            </div>
                            <div class="mb-2">
                                <input class="form-check-input me-2" type="radio"
                                    v-model="postData.transportType.choice" value="Polácinaši">
                                <label class="form-check-label">Poláci naši</label>
                            </div>
                            <div class="mb-2">
                                <input class="form-check-input me-2" type="radio"
                                    v-model="postData.transportType.choice" value="LogrealPešek">
                                <label class="form-check-label">Logreal Pešek</label>
                            </div>
                            <div class="mb-2">
                                <input class="form-check-input me-2" type="radio"
                                    v-model="postData.transportType.choice" value="other">
                                <label class="form-check-label">{{ $t('transportations.different') }}</label>
                            </div>
                            <div v-if="postData.transportType.choice == 'other'">
                                <label class="form-check-label">{{ $t('transportations.whoILoaded') }}:</label>
                                <input class="form-control" type="text"
                                    v-model="postData.transportType.differentChoice">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {{ postData.transportType.transportType }}
            <!-- Date -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label" for="date">
                    {{ $t("transportations.date") }} <span class="text-danger">*</span>
                </label>
                <input id="date" type="date" class="form-control" v-model="postData.date">
            </div>

            <!-- Driver -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.driver") }}
                </label>
                <select class="form-select" v-model="postData.driver">
                    <option value="" disabled>{{ $t('transportations.chooseDriver') }}..</option>
                    <option v-for="driver in drivers" :value="driver.id" v-key="driver.id">
                        {{ driver.first_name }} {{ driver.last_name }}
                    </option>
                </select>
            </div>
            <!-- Recipient -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.woodTransportFor") }}
                </label>
                <button class="btn" data-bs-toggle="modal" data-bs-target="#recipientModal"
                    style="border: 2px solid grey;">
                    <div class="d-flex gap-5">
                        <span v-if="postData.recipient">{{ postData.recipient.name }}</span>
                        <span v-else>{{ $t('transportations.chooseRecipient') }}..</span>
                    </div>
                </button>
                <AddTransportationPopup id="recipientModal" :header="$t('transportations.chooseRecipient')"
                    @save-data="addRecipient">
                    <template v-slot:list>
                        <div v-for="recipient in data.recipients" :key="recipient.id" class="mb-2 d-flex justify-content-between me-4">
                            <div>
                                <input class="form-check-input me-2" type="radio" :id="recipient.id" :value="recipient"
                                    v-model="postData.recipient">
                                <label class="form-check-label" :for="'recipient' + recipient.id">
                                    {{ recipient.name }}
                                </label>
                            </div>
                            <div>
                                <button type="button" class="btn btn-danger" @click="removeRecipient(recipient.id)">{{
                                    $t("utils.hide") }}</button>
                            </div>
                        </div>
                    </template>
                </AddTransportationPopup>
            </div>
            <!-- CMR or Wagon -->
            <div class="form-check-label">{{ $t("transportations.cmrLabel") }}</div>
            <div class="p-3 mb-2 border rounded border-secondary">
                <div v-for="(field, index) in postData.cmrOrWagon" :key="index" class="d-flex align-items-center mb-3">
                    <!-- CMR or Wagon -->
                    <div class="w-50 d-flex flex-column me-3">
                        <label class="form-check-label">
                            {{ $t("transportations.cmrOrWagon") }}
                        </label>
                        <input class="form-control" type="text" v-model="field.cmrOrWagon">
                    </div>
                    <!-- Amount -->
                    <div class="w-50 d-flex flex-column">
                        <label class="form-check-label">
                            {{ $t("transportations.amount") }}
                        </label>
                        <input type="number" min="0" v-model="field.amount" class="form-control">
                    </div>
                    <button v-if="index > 0" type="button" class="btn btn-outline-danger ms-2 mt-4"
                        @click="removeField(index, 'cmr')"><strong>-</strong></button>
                    <button type="button" class="btn btn-outline-primary ms-2 mt-4"
                        @click="addField('cmr')"><strong>+</strong></button>
                </div>
            </div>

            <!-- Subscriber -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.subscriber") }} <span class="text-danger">*</span>
                </label>
                <button class="btn" data-bs-toggle="modal" data-bs-target="#subscriberModal"
                    style="border: 2px solid grey;">
                    <div class="d-flex gap-5">
                        <span v-if="postData.subscriber">{{ postData.subscriber.name }}</span>
                        <span v-else>{{ $t('transportations.chooseSubscriber') }}..</span>
                    </div>
                </button>
                <AddTransportationPopup id="subscriberModal" :header="$t('transportations.chooseSubscriber')"
                    @save-data="addSubscriber">
                    <template v-slot:list>
                        <div v-for="subscriber in data.subscribers" :key="subscriber.id"
                            class="mb-2 d-flex justify-content-between me-4">
                            <div>
                                <input class="form-check-input me-2" type="radio" :id="subscriber.id"
                                    :value="subscriber" v-model="postData.subscriber">
                                <label class="form-check-label" :for="'subscriber' + subscriber.id">
                                    {{ subscriber.name }}
                                </label>
                            </div>
                            <div>
                                <button type="button" class="btn btn-danger" @click="removeSubscriber(subscriber.id)">{{
                                    $t("utils.hide") }}</button>
                            </div>
                        </div>

                    </template>
                </AddTransportationPopup>
            </div>

            <!-- Sortiment -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.sortiment") }}
                </label>
                <button class="btn" data-bs-toggle="modal" data-bs-target="#sortimentModal"
                    style="border: 2px solid grey;">
                    <div class="d-flex gap-5">
                        <span v-if="postData.sortiment">{{ postData.sortiment.name }}</span>
                        <span v-else>{{ $t('transportations.chooseSortiment') }}..</span>
                    </div>
                </button>
                <AddTransportationPopup id="sortimentModal" :header="$t('transportations.chooseSortiment')"
                    @save-data="addSortiment">
                    <template v-slot:list>
                        <div v-for="sortiment in data.wood_types" :key="sortiment.id"
                            class="mb-2 d-flex justify-content-between me-4">
                            <div class="">
                                <input class="form-check-input me-2" type="radio" :id="sortiment.id" :value="sortiment"
                                    v-model="postData.sortiment">
                                <label class="form-check-label" :for="'sortiment' + sortiment.id">
                                    {{ sortiment.name }}
                                </label>
                            </div>
                            <div>
                                <button type="button" class="btn btn-danger" @click="removeSortiment(sortiment.id)">{{
                                    $t("utils.hide") }}</button>
                            </div>
                        </div>
                    </template>
                </AddTransportationPopup>
            </div>

            <!-- Loading and Unloading -->
            <div class="form-check-label">{{ $t("transportations.location") }}</div>
            <div class="p-3 mb-2 border rounded border-secondary">
                <div v-for="(field, index) in postData.loadingUnloading" :key="index" class="d-flex mb-3">
                    <!-- Place of loading -->
                    <div class="w-50 d-flex flex-column me-3">
                        <label class="form-check-label">
                            {{ $t("transportations.placeOfLoading") }}
                        </label>
                        <input type="text" class="form-control" v-model="field.loading">
                    </div>
                    <!-- Place of delivery -->
                    <div class="w-50 d-flex flex-column">
                        <label class="form-check-label">
                            {{ $t("transportations.placeOfDelivery") }}
                        </label>
                        <input type="text" class="form-control" v-model="field.unloading">
                    </div>

                    <button v-if="index > 0" type="button" class="btn btn-outline-danger ms-2 mt-4"
                        @click="removeField(index, 'loadingUnloading')">
                        <strong>-</strong>
                    </button>
                    <button type="button" class="btn btn-outline-primary ms-2 mt-4"
                        @click="addField('loadingUnloading')"><strong>+</strong></button>
                </div>
            </div>

            <!-- SPZ -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.spz") }} <span class="text-danger">*</span>
                </label>
                <button class="btn" data-bs-toggle="modal" data-bs-target="#spzModal" style="border: 2px solid grey;">
                    <div class="d-flex gap-5">
                        <span v-if="postData.spz">{{ postData.spz.name }}</span>
                        <span v-else>{{ $t('transportations.chooseSpz') }}..</span>
                    </div>
                </button>
                <AddTransportationPopup id="spzModal" :header="$t('transportations.chooseSpz')" @save-data="addSpz">
                    <template v-slot:list>
                        <div v-for="spz in data.licence_plates" :key="spz.id"
                            class="mb-2 d-flex justify-content-between me-4">
                            <div>
                                <input class="form-check-input me-2" type="radio" :id="spz.id" :value="spz"
                                    v-model="postData.spz">
                                <label class="form-check-label" :for="'spz' + spz.id">
                                    {{ spz.name }}
                                </label>
                            </div>
                            <div>
                                <button type="button" class="btn btn-danger" @click="removeSpz(spz.id)">{{
                                    $t("utils.hide") }}</button>
                            </div>
                        </div>
                    </template>
                </AddTransportationPopup>
            </div>
        </div>
        <!-- Button -->
        <div>
            <button class="btn btn-primary form-submit" @click="submitForm()">{{ $t("utils.submit") }}</button>
        </div>
    </div>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import AddTransportationPopup from '@/components/AddTransportationPopup.vue';

export default {
    components: { VueDatePicker, AddTransportationPopup },
    data() {
        return {
            data: [],
            drivers: [],
            postData: {
                transportType: { transportType: null, choice: null, differentChoice: null },
                date: '',
                driver: '',
                cmrOrWagon: [{ cmrOrWagon: "", amount: null }],
                loadingUnloading: [{ loading: "", unloading: "" }],
                spz: '',
                recipient: '',
                subscriber: '',
                sortiment: '',
            },
            error: null,
            spzSelection: '',
            subscriberSelection: '',
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/drivers/transportations").then((response) => {
                this.drivers = response.data.items;
            })
            this.$store.getters.api.get("/transportations/data").then((response) => {
                this.data = response.data.items;
            })
        },
        addField(type) {
            if (type == "cmr") {
                this.postData.cmrOrWagon.push({ cmrOrWagon: "", amount: null });
            }
            else if (type == "loadingUnloading") {
                this.postData.loadingUnloading.push({ loading: "", unloading: "" });
            }
        },
        removeField(index, type) {
            if (type == "cmr") {
                this.postData.cmrOrWagon.splice(index, 1);
            }
            else if (type == "loadingUnloading") {
                this.postData.loadingUnloading.splice(index, 1);
            }
        },
        submitForm() {
            if (
                !this.postData.subscriber ||
                !this.postData.date ||
                !this.postData.spz
            ) {
                this.error = this.$t("error.missingFields");
            }
            else {
                let postData = {
                    transportType: this.postData.transportType,
                    date: this.postData.date,
                    driver: this.postData.driver,
                    cmrOrWagon: this.postData.cmrOrWagon,
                    loadingUnloading: this.postData.loadingUnloading,
                    spz: this.postData.spz.id,
                    recipient: this.postData.recipient.id,
                    subscriber: this.postData.subscriber.id,
                    sortiment: this.postData.sortiment.id,
                }
                this.$store.getters.api.post("/transportation/add", postData)
                    .then((response) => {
                        this.$router.push({ name: "Transportations" });
                    })
            }
        },
        addRecipient(newRecord) {
            this.$store.getters.api.post("/recipients/add", { name: newRecord })
                .then((response) => {
                    this.loadData();
                });
        },
        addSubscriber(newRecord) {
            this.$store.getters.api.post("/subscribers/add", { name: newRecord })
                .then((response) => {
                    this.loadData();
                });
        },
        addSortiment(newRecord) {
            this.$store.getters.api.post("/wood_types/add", { name: newRecord })
                .then((response) => {
                    this.loadData();
                });
        },
        addSpz(newRecord) {
            this.$store.getters.api.post("/licence_plates/add", { name: newRecord })
                .then((response) => {
                    this.loadData();
                });
        },
        removeRecipient(id) {
            this.$store.getters.api.put(`/recipient/${id}/hide`)
                .then((response) => {
                    this.loadData();
                });
        },
        removeSubscriber(id) {
            this.$store.getters.api.put(`/subscriber/${id}/hide`)
                .then((response) => {
                    this.loadData();
                });
        },
        removeSortiment(id) {
            this.$store.getters.api.put(`/wood_type/${id}/hide`)
                .then((response) => {
                    this.loadData();
                });
        },
        removeSpz(id) {
            this.$store.getters.api.put(`/licence_plate/${id}/hide`)
                .then((response) => {
                    this.loadData();
                });
        }
    }
}

</script>
<style lang="">

</style>
